import styled, { keyframes } from 'styled-components';
const loadingAnimation = keyframes `
  to {
    background-position: 200% center;
  }
`;
export const SkeletonMicroPropertyCard = styled.div `
  position: relative;
  min-height: 273px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-position: -100% center;
    background-size: 40%;
    background-repeat: no-repeat;
    animation-name: ${loadingAnimation};
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
`;
export const SkeletonImageContainer = styled.div `
  background-color: ${({ theme }) => theme.ColorGrey100};
  height: 0;
  padding-top: ${() => `${(61 / 110) * 100}%`};
  width: 100%;
`;
export const SkeletonTitle = styled.div `
  background-color: ${({ theme }) => theme.ColorGrey100};
  height: 16px;
  width: 75%;
`;
export const SkeletonGradeContainer = styled.div `
  background-color: ${({ theme }) => theme.ColorGrey100};
  height: 16px;
  width: 35%;
`;
export const SkeletonPropertySpecs = styled.div `
  background-color: transparent;
  height: 40px;
  width: 100%;
`;
export const SkeletonPriceSection = styled.div `
  background-color: ${({ theme }) => theme.ColorGrey100};
  height: 16px;
  width: 35%;
`;
//# sourceMappingURL=micro-property-card-skeleton.styles.js.map